<template>
	<div>
		<div class="stream-display">
			<img class="pointer absolute min-w-100" :class="{'z-index-min1': !visibleElement}" @click="toggleBg" v-if="backgroundColor === '#FFFFFF' && isBgToggled" :src="imgTransparentChecker" alt="Grafias" >
			<img class="pointer absolute min-w-100" :class="{'z-index-min1': !visibleElement}" @click="toggleBg" v-if="backgroundColor === '#FFFFFF' && !isBgToggled" :src="imgTransparentCheckerDark" alt="Grafias">
			<transition name="fade">
					<span class="pointer">
					<span v-show="!visibleElement" @click="toggleBg" class="z-index-1">
						<img :src="activeBgColor" alt="Grafias" class="min-w-100">
					</span>
				</span>
			</transition>
			<transition name="fade">
			<div>
				<stream-item-play :status="live" :item="visibleElement" :key="visibleElement.id"></stream-item-play>
			</div>
			</transition>
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import { mapActions } from 'vuex';
import { getAxiosErrorMessage } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import StreamItemPlay from '@/components/StreamItemPlay.vue';

export default {
	name: 'StreamDisplayItemRundown',
	components: {
		StreamItemPlay,
	},
	props: {
		type: {
			type: String,
			default: 'live',
		},
	},
	data() {
		return {
			rundown: {},
			item: {},
			whiteTransparentBg: '/img/logo/Grafias_FULLHD_White_transparent.png',
			darkTransparentBg: '/img/logo/Grafias_FULLHD_DARK_transparent.png',
			backgroundColor: 'transparent',
			imgTransparentChecker: '/img/checkertransparent_light.png',
			imgTransparentCheckerDark: '/img/checkertransparent_dark.png',
			isBgToggled: false,
		};
	},
	created() {
		this.$nextTick(() => {
			$('body').css('background-color', 'transparent');
			$('html.md-theme-default').css('background-color', 'transparent');
			$(document).find('main').removeClass('main');
			$('html').css('overflow', 'hidden');
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
		});
		this.fetchItem();
	},
	destroyed() {
	},
	beforeDestroy() {
		this.$nextTick(() => {
			$(document).find('main').addClass('main');
			$('body').css('background-color', '');
			$('html.md-theme-default').css('background-color', '');
			$('html').css('overflow', 'visible');
			this.setNavbarVisible(true);
			this.setDrawerVisible(true);
		});
	},
	mounted() {

	},
	methods: {
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		toggleBg() {
			this.isBgToggled = !this.isBgToggled;
		},
		fetchItem() {
			const callback = (response) => {
				const item = response.data;
				this.item = item;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
			};
			rundownItemsApi.get(this.itemId, callback, errorCallback);
		},
		setBackground() {
			this.backgroundColor = this.rundown ? this.rundown.background_color : 'transparent';
		},
	},
	computed: {
		visibleElement() {
			return this.item;
		},
		activeBgColor() {
			return this.backgroundColor === '#FFFFFF' || this.backgroundColor === '#00FF00' ? this.darkTransparentBg : this.whiteTransparentBg;
		},
		itemId() {
			return this.$route.params.id;
		},
	},
	watch: {
	},
};
</script>
